export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          了解51吃瓜爆料网的故事
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/80 p-8 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 md:gap-10 items-start">
              <div className="flex-1">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
                  关于51吃瓜爆料网
                </h3>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    51吃瓜爆料网成立于2024年，是国内领先的吃瓜娱乐内容聚合平台。我们致力于为吃瓜爱好者提供最新、最全、最有趣的网红吃瓜内容，涵盖台北娜娜、玩偶姐姐、莫里秀等热门网红的实时动态与经典名场面。
                  </p>
                  <p>
                    平台以<strong>轻量版吃瓜短视频</strong>为核心体验，让用户在任何网络环境下都能流畅观看热播吃瓜短视频。我们的编辑团队每日筛选全网优质内容，直击吃瓜娱乐现场与网红直播翻车片段，确保每一条推送都值得一看。
                  </p>
                  <p>
                    从搞笑吃瓜瞬间到吃瓜真人秀片段，51吃瓜爆料网始终坚持内容为王，为千万用户打造一个欢乐、轻松、有温度的吃瓜社区。欢迎加入我们，一起发现更多精彩的吃瓜内容！
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 mt-6">
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-user-line text-primary-500"></i>
                    <span>千万用户信赖</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-calendar-check-line text-primary-500"></i>
                    <span>每日更新200+</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-shield-check-line text-primary-500"></i>
                    <span>内容严格甄选</span>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-[200px] flex-shrink-0">
                <div className="bg-gradient-to-br from-primary-100 to-accent-100 rounded-2xl p-6 text-center">
                  <div className="text-3xl font-extrabold text-primary-600 mb-1">200+</div>
                  <div className="text-xs text-foreground-500">日均更新</div>
                  <div className="w-full h-px bg-primary-200 my-4"></div>
                  <div className="text-3xl font-extrabold text-accent-600 mb-1">300+</div>
                  <div className="text-xs text-foreground-500">覆盖网红</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}